import { render, staticRenderFns } from "./FormerlyKnownAs.vue?vue&type=template&id=73fc20ee"
import script from "./FormerlyKnownAs.vue?vue&type=script&lang=js"
export * from "./FormerlyKnownAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports